var map = {
	"./couch.jpg": 7064,
	"./desk.jpg": 4403,
	"./desk_bottom.jpg": 6832,
	"./desk_center.jpg": 3655,
	"./domestic_interior_1.jpg": 410,
	"./domestic_interior_2.jpg": 6658,
	"./domestic_interior_3.jpg": 5562,
	"./ferry.jpg": 3225,
	"./gallery.jpg": 1999,
	"./jacqueline.jpg": 777,
	"./lighthouse.jpg": 8832,
	"./merrit.jpg": 9874,
	"./mum_breakfast.jpg": 7078,
	"./obamame.jpg": 1096,
	"./piano.jpg": 7538,
	"./pikame.jpg": 5048,
	"./pool.jpg": 8941,
	"./pumpkinme.jpg": 7850,
	"./queenme.jpg": 918,
	"./russianriver.jpg": 2647,
	"./self.jpg": 2343,
	"./sheepme.jpg": 7475,
	"./warholme.jpg": 9429,
	"./waterlandscape.jpg": 2118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1797;